module.exports = __webpack_public_path__ + "img/tips-icon.a38d714b.svg";